import { render, staticRenderFns } from "./TipoGastoList.vue?vue&type=template&id=6690a4c6&"
import script from "./TipoGastoList.vue?vue&type=script&lang=js&"
export * from "./TipoGastoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports